const crypto = window.crypto;

export function getRandomInt32() {
    if (crypto?.getRandomValues) {
        const randomBuffer = new Uint32Array(1);
        crypto.getRandomValues(randomBuffer);
        return randomBuffer[0];
    } else {
        return Math.floor(Math.random() * 1e9);
    }
}

export function getRandomFloat() {
    if (crypto?.getRandomValues) {
        const randomBuffer = new Uint32Array(1);
        crypto.getRandomValues(randomBuffer);
        return randomBuffer[0] / (0xffffffff + 1);
    } else {
        return Math.random();
    }
}